export const booleanValidar = (string: string) => {
	if (string === "true") {
		return "Provisional";
	} else if (string === "false") {
		return "Definitivo";
	}
	return string;
};
